(function (Wishlist, $) {
  var $wishlistButton = $('.wishlist-btn');
  var $wishlistTile = $('.wishlist-tile-container');
  var numProductTiles = $wishlistTile.length;
  var wishlist = localStorage.getItem('user_wishlist') || [];
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }

  /*
   * Update button to show current state (gold for active)
   */   
  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   
  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('is-active');
    
    /* Remove */
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      $("#wishlist_update .wishlist_item").each(function(){
       var all_handle = $(this).attr('data-product-handle');
        if(all_handle == productHandle){
          $(this).fadeOut(1000);
        }
      });
    }
    /* Add */ 
    else {
      wishlist.push(productHandle);
      var saved_item = localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    }
    console.log(JSON.stringify(wishlist));
  };

  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('is-active');
      }
    });
  };

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */   
  var displayOnlyWishlistItems = function () {
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
  };

  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
  
  var loadWishlist = function () {
    if(wishlist.lenght == null ){
      $('.wishlist-grid.flex').addClass('is_visible');
      $('.wishlist-loader').fadeOut(2000);
    }
    
  //  Currency.convertAll("", jQuery('.currencies').val(), 'span.money', 'money_format');  
  // Currency.convertAll("EUR", 'EUR', 'span.money', 'money_format');
      if(undefined!=document.getElementById("RecentProductItemScript")){
         var source = document.getElementById("RecentProductItemScript").innerHTML;
      }
     for (var i = 0; i < wishlist.length; i++){ 
       $('.wishlist-grid--empty-list').hide();
       $('.wishlist-grid').addClass('is_visible');
       $('.wishlist-hero').addClass('is_visible');
       $('.wishlist-loader').fadeOut(2000);
       var productAjaxURL = "/products/" + wishlist[i] + ".js";
        $.ajax({
          type: 'GET',
          dataType: 'json',
          url: productAjaxURL,
          success: function (data) {
            var template = Handlebars.compile(source);
            var context = {
              handle: data.handle,
              id: data.id,
              variants: data.variants,
              length: data.variants.length,
              first_variant_id: data.variants[0].id,
              title: data.title,
              url: data.url,
              image: data.featured_image,
              vendor: data.vendor,
              /*compare_price:Shopify.formatMoney(data.compare_at_price, ""),
              price: Shopify.formatMoney(data.price, ""),
              compare_price = Intl.NumberFormat(Shopify.locale, {style: 'currency',currency: Shopify.currency.active}).format(Shopify.formatMoney(data.compare_at_price).replace("$","")),                                  
              price = Intl.NumberFormat(Shopify.locale, {style: 'currency',currency: Shopify.currency.active}).format(Shopify.formatMoney(data.price).replace("$","")),
              compare_price:Shopify.formatMoney(data.compare_at_price).replace("$",Shopify.currency.active+' '),
              price: Shopify.formatMoney(data.price).replace("$",Shopify.currency.active+' '),
              firstSKU: data.variants[0].sku,*/
              productAvailable: data.available
            };
            var html = template(context);  
            $(html).appendTo("#wishlist_update");

          },
          error: function (data, error) {
            $('.wishlist-grid--empty-list').addClass('is_visible');
          }
        });
      }
  };
  
  var bindUIActions = function () {
    $(document).on('click','.wishlist-btn', function(e){
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
  };

  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
  };

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));